import React, { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Home from '../Components/Web/Home/Home'
import Products from '../Components/Web/Products/Products'
import Team from '../Components/Web/Team/Team'
import Contact from '../Components/Web/Contact/Contact'
import Projects from '../Components/Web/Projects/Projects'
import Product from '../Components/Web/Product/Product'
import Gallery from '../Components/Web/Gallery/Gallery'
import CaseStudy from '../Components/Web/CaseStudy/CaseStudy'
import PrivacyPolicy from '../Components/Web/TermsAndConditions/PrivacyPolicy'
import TermsofServices from '../Components/Web/TermsAndConditions/TermsofServices'
import Cookies from '../Components/Web/TermsAndConditions/Cookies'

function Routing() {
  const location = useLocation()
  const isDark = useSelector(state => state.functionslice.value.isDark)

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0)
    } else {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location])

  useEffect(() => {
    document.body.setAttribute('data-theme', isDark ? 'dark' : 'light')
  }, [isDark])

  return (
    <>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path="products/:name" element={<Products />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/casestudy" element={<CaseStudy />} />
        <Route path="/product" element={<Product />} />
        <Route path="projects/:name" element={<Projects />} />
        <Route path='/team' element={<Team />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/privacypolicy' element={<PrivacyPolicy />} />
        <Route path='/termsofservice' element={<TermsofServices />} />
        {/* <Route path='/cookies' element={<Cookies />} /> */}
      </Routes>
    </>
  )
}

export default Routing
